module.exports = __webpack_public_path__ + "img/downL.0da034b7.jpg";